import { inject, Injectable, signal } from "@angular/core";
import { EventSummary } from "@interfaces";
import { FuncService } from "../../../../../../services";

@Injectable({ providedIn: 'root' })
export class AccClassEventsViewerDialogDataService {

	private func = inject(FuncService);

	private readonly _classEvents = signal<EventSummary[]>([]);
	readonly classEvents = this._classEvents.asReadonly();

	setClassEvents(classEvents: EventSummary[]) {
		this._classEvents.set(classEvents);
	}

	public async getClassEventsSummary(accId: number) {
		this._classEvents.set(await this.func.event.getClassEventsSummaryForAccId({ accId }));
	}

}